/**
 * Name: Burger
 */

import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";
import { setInertOutside } from '../Navigation/inert';

export default class Burger extends Collapsible {
  static settings = {
    control: '.js-burger',
    target: '.js-navigations',
  };

  #closeButton;

  constructor (element, options = {}) {
    super(element, {
      ...Burger.settings,
      ...options,
    });

    this.handleLinkClicks = this.handleLinkClicks.bind(this);
    this.handleCloseClick = this.close.bind(this);
    this.#closeButton = document.querySelector('.js-burger-close');
  }

  get isDisplayed () {
    return getComputedStyle(this.element).display !== 'none';
  }

  open () {
    super.open();
    document.querySelector('header').classList.add('is-open');
    document.querySelector('.js-burger span').innerHTML = "Fermer";
    document.querySelector('html').classList.add('no-scroll');
    document.querySelector('header').ontransitionend = (event) => {
      // `transitionend` bulle : sans ce garde-fou, la transition de
      // n'importe quel descendant (sous-menu qui s'ouvre, lien survolé,
      // focus visible...) remettait le scroll du panneau à 0, rendant le
      // menu mobile impossible à parcourir dès qu'on interagit avec lui.
      if (event.target === document.querySelector('header')) {
        document.querySelector('header').scrollTop = 0;
      }
    };

    if (document.body.classList.contains("admin-bar")) {
      document.querySelector('header').style.top = `${50}px`;
    }

    const nav = document.querySelector('#navigation');
    if (nav) {
      setInertOutside(nav, document.body, true);
    }

    // Le header est en `position: sticky` (toujours visible) : on évite le
    // scroll-into-view automatique du navigateur, qui recalcule sa position
    // comme si le header n'était pas sticky et ramène la page en haut.
    this.target.focus({ preventScroll: true });

    this.target.addEventListener('click', this.handleLinkClicks);
  }

  close (refocus = true) {
    super.close(refocus);
    document.querySelector('header').classList.remove('is-open');
    document.querySelector('.js-burger span').innerHTML = "Menu";
    document.querySelector('header').classList.remove('is-megamenu-open');
    document.querySelector('html').classList.remove('no-scroll');

    if (document.body.classList.contains("admin-bar")) {
      document.querySelector('header').style.top = `0`;
    }

    const nav = document.querySelector('#navigation');
    if (nav) {
      setInertOutside(nav, document.body, false);
    }

    this.target.removeEventListener('click', this.handleLinkClicks);
  }

  // Ne ferme pas automatiquement quand le focus sort du tiroir de
  // navigation : le reste de la page est déjà rendu inerte pendant qu'il
  // est ouvert (voir `open`/`close`), donc il n'y a pas de piège clavier à
  // éviter. Fermer en réaction à un focus qui s'échappe s'est révélé
  // instable avec VoiceOver — seules les fermetures explicites (bouton
  // burger, bouton "Fermer le menu", Échap) restent fiables.
  _handleFocusout () {}

  handleLinkClicks(event) {
    const clickedElement = event.target;

    const linkElement = clickedElement.closest('a');

    if (linkElement && !linkElement.hasAttribute('role') && linkElement.getAttribute('href') !== '#') {
      this.close();
    }
  }

  mount () {
    super.mount();
    this.target.setAttribute('tabindex', '-1');

    if (this.#closeButton) {
      this.#closeButton.addEventListener('click', this.handleCloseClick);
    }
  }

  unmount () {
    super.unmount();
    console.log('unmount');
    this.target.classList.remove('has-open');
    document.querySelector('.js-burger span').innerHTML = "Menu";
    this.target.removeEventListener('click', this.handleLinkClicks);

    if (this.#closeButton) {
      this.#closeButton.removeEventListener('click', this.handleCloseClick);
    }
  }
}
